module.exports = __webpack_public_path__ + "static/media/Step2.4e57f55d.svg";